/**
 * Step 2: アイコン選択方法ステップ
 *
 * 3択: プリセット、アップロード、AI生成
 */
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { CreateUserState, IconMethod, WizardStep } from "../types";

interface IconMethodStepProps {
  state: CreateUserState;
  updateState: (updates: Partial<CreateUserState>) => void;
  goToStep: (step: WizardStep) => void;
}

export const IconMethodStep = ({ updateState, goToStep }: IconMethodStepProps) => {
  const play = usePlaySound();

  const handleSelectPreset = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PRESET, icon: "" });
      goToStep(WizardStep.PRESET_ICON);
    });
  };

  const handleSelectUpload = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.UPLOAD, icon: "" });
      goToStep(WizardStep.UPLOAD_ICON);
    });
  };

  const handleSelectProfileAI = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PROFILE_AI, icon: "" });
      goToStep(WizardStep.PROFILE_AI);
    });
  };

  return (
    <div className="flex-col-el flex-center w-full h-full">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[32px]">
          {I18n.t("MSG_ICON_SELECT_TITLE")}
        </p>
      </div>

      {/* 選択カード - 3択 */}
      <div className="flex-row-el flex-center gap-4">
        {/* プリセットから選ぶ */}
        <div
          onClick={handleSelectPreset}
          className="flex-col-el items-center justify-center w-[240px] h-[240px] rounded-[4px] bg-green-100 cursor-pointer select-none active:scale-95"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">grid_view</span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_SYSTEM")}
          </p>
        </div>

        {/* アップロード */}
        <div
          onClick={handleSelectUpload}
          className="flex-col-el items-center justify-center w-[240px] h-[240px] rounded-[4px] bg-orange-100 cursor-pointer select-none active:scale-95"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">upload</span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_UPLOAD")}
          </p>
        </div>

        {/* プロフィールから作る */}
        <div
          onClick={handleSelectProfileAI}
          className="flex-col-el flex-center w-[240px] h-[240px] rounded-[4px] bg-blue-100 cursor-pointer select-none active:scale-95"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3 mt-8">
            auto_awesome
          </span>
          <p className="text-body text-[22px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_PROFILE_AI")}
          </p>
        </div>
      </div>
    </div>
  );
};
